import React, { Component } from 'react';
import EPLogo from '../assets/ico-logo-ep.svg';
import TBLogo from '../assets/ico-logo-tb.svg';

class Header extends Component {
    render() {
        if (this.props.brand === "EP") {
            return (
                <img id="dsLOGO" src={EPLogo} alt="Exampro logo" max-width="50%"></img>
            )
        } else {
            return (
                <img id="dsLOGO" src={TBLogo} alt="Testbase logo" max-width="50%"></img>
            )
        }

    }
}

export default Header;